import { formatMoney } from 'theme';
import { getProductTitleParts } from 'swatches';
import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function productCardTemplate(item) {
  const [title] = getProductTitleParts(item.title);
  const price = item.compare_at_price > item.price
    ? html` 
      <span class="ac-compare-at-price line-through">
        <span class="sr-only">Regular price:</span>
        ${formatMoney(item.compare_at_price * 100)}
      </span>
      <span class="ac-sale-price text-on-sale">
        <span class="sr-only">Sale price:</span>
        ${formatMoney(item.price * 100)}
      </span>`

    : html`<span class="ac-price">${formatMoney(item.price * 100)}</span>`;

  return html`
    <a href="/products/${item.handle}" class="ac-product-card">
      <img src="${item.image}" alt="" loading="lazy" />
      <div class="ac-product-card__title">${title}</div>
      <div class="ac-product-card__price">${price}</div>
    </a>
  `;
}